module.exports = __webpack_public_path__ + "static/media/16UNODC33.037012b1.jpg";